import Component from './src/index.vue';
import { NavTabsInfo } from './src/business';

export {
  NavTabsInfo,
};

export default Component;
